import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gameName" }
const _hoisted_2 = { class: "subText" }
const _hoisted_3 = { class: "subText" }
const _hoisted_4 = { class: "subTitle" }
const _hoisted_5 = { class: "valuText betText" }
const _hoisted_6 = { class: "subTitle" }
const _hoisted_7 = { class: "valuText" }

import { formatCurrency } from '@/utils/commonFunction';

export default /*@__PURE__*/_defineComponent({
  __name: 'logCard',
  props: {
    betAmount: {
        type: Number,
        default: () => 0
    },
    returnAmount: {
        type: Number,
        default: () => 0
    },
    profit: {
        type: Number,
        default: () => 0
    },
    gameName: {
        type: String,
    },
    sessionId: {
        type: String,
    },
    time: {
        type: String,
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createBlock(_component_van_row, {
    class: "bet_card",
    justify: "space-between"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_col, { span: "10" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.gameName), 1),
          _createElementVNode("div", _hoisted_2, "No: " + _toDisplayString(__props.sessionId), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.time), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "4",
        class: "subCol"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('common.bets')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatCurrency)(__props.betAmount)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "4",
        class: "subCol"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.return')), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatCurrency)(__props.returnAmount)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "4",
        class: "subCol"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "subTitle",
            style: _normalizeStyle({ color: __props.profit >= 0 ? '#43d938' : 'red' })
          }, _toDisplayString(__props.profit >= 0 ?
                _ctx.$t('common.profit') : _ctx.$t('common.loss')), 5),
          _createElementVNode("div", {
            class: "valuText",
            style: _normalizeStyle({ color: __props.profit >= 0 ? '#43d938' : 'red' })
          }, _toDisplayString(__props.profit >= 0 ? ' +' : '') + _toDisplayString(_unref(formatCurrency)(__props.profit)), 5)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})